<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขกลุ่มบริษัทของผู้ให้บริการโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="formEdit"
                    ref="formEdit"
                  >
                    <div class="row">
                      <div class="col-xs-12">
                        <el-form size="mini">
                          <el-form-item label="ชื่อกลุ่มบริษัท">
                            <el-input
                            style="max-width: 450px"
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="formEdit.group_name"
                              clearable
                              show-word-limit
                              maxlength="20"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อรายการบริษัททั้งหมด">
                            <el-checkbox-group  v-model="formEdit.company_lists">
                              <template v-for="provider in store_providers">
                                <el-checkbox v-if="provider.type_tag == 'mobile'" :label="provider.info" :key="provider.info" :disabled="!ungroup_id.includes(provider.info)">{{provider.brand_name}}</el-checkbox>
                              </template>
                            </el-checkbox-group>
                          </el-form-item>
                          <el-form-item label="โลโก้กลุ่มบริษัท">
                            <el-upload
                              class="avatar-uploader"
                              action="#"
                              ref="file"
                              :auto-upload="false"
                              :show-file-list="false"
                              :on-change="onFileChange"
                              accept="image/jpeg,image/png"
                            >
                              <img v-if="formEdit.logo" :src="formEdit.logo" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                          <el-form-item label="โค้ดสีกลุ่มบริษัท (ใช้สำหรับรายงาน)">
                            <el-input
                              placeholder="กรุณากรอกข้อมูล"
                              v-model="formEdit.color"
                              type="color"
                              style="width:300px;"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="box-footer">
                      <el-button style="float: left" type="secondary" @click="back">ยกเลิก</el-button>
                      <el-button style="float: right" type="primary" @click="submitForm">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      label_position: "top",
      selectType: [
        {
          value: "mobile",
          label: "โทรศัพท์เคลื่อนที่"
        },
        {
          value: "broadband",
          label: "อินเทอร์เน็ตความเร็วสูงประจำที่"
        }
      ],
      formEdit: {
        id:'',
        group_name: '',
        group_type:'',
        company_lists: [],
        logo : '',
        color: '',
        file: null
      },
      ungroup_id : []
    };
  },
  created(){
    this.allProvider()
    this.$store.dispatch('ListOperator/get_ungroup_operator')
  },
  mounted() {
    if(!this.prepare) this.$router.push({ name: 'Typegroup' });
    this.formEdit.id = this.prepare.id
    this.formEdit.group_name = this.prepare.group_name_th
    this.formEdit.color = this.prepare.group_color_code
    this.formEdit.logo = this.prepare.logo
    this.formEdit.company_lists = JSON.parse(this.prepare.group_company_list)
    this.ungroup_id = JSON.parse(this.prepare.group_company_list)
    for(let pv of this.store_ungroup) this.ungroup_id.push(pv.id);
  },
  computed: {
    ...mapState({
      store_providers: store => store.ListOperator.operators,
      store_ungroup: store => store.Typegroup.ungroup,
      prepare: store => store.Typegroup.prepare
    })
  },
  methods: {
    ...mapActions({
      getProvider: "ListOperator/search",
      allProvider: "ListOperator/fetch_table",
      editGroup: "Typegroup/updateTypegroup"
    }),
    onFileChange(e) {
      this.formEdit.file = e.raw;
      this.formEdit.logo = URL.createObjectURL(this.formEdit.file);
    },
    submitForm() {
        let string_lists = JSON.stringify(this.formEdit.company_lists)
        let formData = new FormData();
          formData.append("id", this.formEdit.id);
          formData.append("group_name", this.formEdit.group_name);
          formData.append("group_type", this.formEdit.group_type);
          formData.append("company_list", string_lists);
          formData.append('color',this.formEdit.color)
          formData.append('file', this.formEdit.file);
        this.editGroup(formData)
    },
    back(){
      this.$router.push({name : 'Typegroup'})
    }
  }
};
</script>
<style >
  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 100%;
  }
</style>